import { Button, Flex, Paper, Select, TextInput } from "@mantine/core";
import { useUnit } from "effector-react";
import { DatePickerInput } from "@mantine/dates";

import { campaignEntityModel } from "../../model/list";
import { CampaignStatus } from "../../types";

export const CampaignsFilters = () => {
  const [filters, update, apply, reset] = useUnit([
    campaignEntityModel.$filters,
    campaignEntityModel.updateFilter,
    campaignEntityModel.applyFilters,
    campaignEntityModel.resetFilters,
  ]);

  return (
    <Paper p="md" radius="md">
      <Flex gap="md" align="flex-end" wrap={{ base: "wrap", md: "nowrap" }}>
        <TextInput
          miw={{ md: "320px", base: "auto" }}
          mt="xs"
          placeholder="Enter a campaign name"
          size="md"
          flex={1}
          value={filters.name}
          onChange={(e) => update({ name: e.currentTarget.value })}
        />

        <DatePickerInput
          w="100%"
          size="md"
          valueFormat="DD/MM/YYYY"
          type="range"
          placeholder="Select date range"
          value={[filters.createdFrom || null, filters.createdTo || null]}
          onChange={([from, to]) =>
            update({ createdFrom: from, createdTo: to })
          }
        />

        <Select
          size="md"
          w="100%"
          data={[
            { value: "", label: "All campaigns" },
            { value: CampaignStatus.pending, label: "In progress" },
            { value: CampaignStatus.failed, label: "Failed" },
            { value: CampaignStatus.completed, label: "Finished" },
          ]}
          value={filters.status ?? ""}
          onChange={(value) => update({ status: value ?? "" })}
        />

        <Flex align="center" gap="md" w="100%">
          <Button fullWidth size="md" onClick={apply}>
            Apply
          </Button>

          <Button fullWidth variant="light" size="md" onClick={reset}>
            Reset
          </Button>
        </Flex>
      </Flex>
    </Paper>
  );
};
